import { base64StringToBlob } from "blob-util";
import { axiosPrivate } from "../axios/axios";
import { masterAPI } from "../Pages/Masters/dataConfig";
import { toast } from "react-toastify";

// Converts the backend's Base64 `fileContents` into a PDF Blob. No
// HTML/canvas rendering is involved, so fonts, tables, page breaks,
// headers/footers and pagination stay exactly as the backend generated them.
const toPdfBlob = (fileContents, contentType) =>
  base64StringToBlob(fileContents, contentType);

// Fetches the PDF for `id` from `link` and returns it as a PDF Blob.
// Backend response shape: { fileContents, contentType, fileDownloadName }.
// Throws a descriptive error for an empty response or invalid data so
// callers can surface it to the user.
const fetchPdfBlob = async (link, id, suffix) => {
  const url = suffix !== undefined ? `${link}/${id}/${suffix}` : `${link}/${id}`;
  const res = await axiosPrivate.get(url);
  const data = res.data?.result ?? res.data ?? {};
  const { fileContents, contentType = "application/pdf" } = data;

  if (!fileContents) {
    console.log(res.data, "print: no fileContents in response");
    throw new Error("No printable document received");
  }

  try {
    return toPdfBlob(fileContents, contentType);
  } catch (e) {
    throw new Error("Received document is not a valid PDF");
  }
};

// Saves `blob` to disk as `fileName`, byte-for-byte, then revokes the URL.
const downloadBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};

// Fetches `id`'s document as a PDF from `link` and downloads it as-is,
// in one click -- no print dialog.
const downloadPdfDocument = async (link, id, fileName, suffix) => {
  if (!id || !link) return;
  try {
    const blob = await fetchPdfBlob(link, id, suffix);
    downloadBlob(blob, fileName);
  } catch (e) {
    console.log("download error:", e?.message || e);
    toast.error(e?.message || "Failed to download PDF");
  }
};

// Downloads the Work Order document exactly as generated by the backend.
export const printWorkOrder = (workOrderId, name) =>
  downloadPdfDocument(
    masterAPI["workOrder"].print,
    workOrderId,
    name ? `${name}.pdf` : "WorkOrder.pdf",
  );

// Downloads the Part Reservation form exactly as generated by the backend.
export const printReservationForm = (workOrderId, name, flag) =>
  downloadPdfDocument(
    masterAPI["partsReservation"].print,
    workOrderId,
    name ? `${name}.pdf` : "ReservationForm.pdf",
    flag,
  );
